export default __webpack_public_path__ + "media/images/mastheads/slider-v201611-e5110fe95e41fa275fe8bddb2c1d558a.jpg";